import { ComponentProps } from "react";
import { Button } from "@thenounproject/lingo-core";

export const MarketingButtons: Record<string, ComponentProps<typeof Button>> = {
  tryFree: { text: "Try for Free", link: "/get-started" },
  scheduleCall: { text: "Schedule a Call", link: "/book-demo" },
  getStarted: { text: "Try for free", link: "/get-started" },
  contactSales: { text: "Contact sales", link: "/contact-sales" },
  contact: { text: "Contact us", link: "/contact" },
  bookDemo: { text: "Get a Demo", link: "/book-demo" },
  calculatePrice: { text: "Calculate your price", link: "/pricing/calculator" },
  startTrial: { text: "Try for free", link: "/get-started" },
  samplePortal: { text: "See a Sample Portal", link: "https://redditbrand.lingoapp.com/" },
  refer: { text: "Start Referring Now", link: "/refer." },
};
